import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../_services/token.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);
  const token = tokenService.getToken();

  if (token !== null) {
    // Optionally decode token or just check presence
    // You can add role checks here if needed
    return true;
  }

  localStorage.setItem('redirectUrl', state.url);
  router.navigateByUrl('/login');
  return false;
};
